(ns ui.editors.card.associations.view
  (:require
   [common.util :as cu]
   [ui.components.toggle.view :as toggle]
   [ui.editors.labelled-input.view :as labelled-input]
   [ui.util :as uu]
   [re-frame.core :as rf]
   [ui.editors.card.associations.sub :as sub]
   [ui.components.button.view :as button]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
   [ui.editors.card.associations.event :as event]
   [ui.components.radio-group.view :as radio-group]
   [ui.components.select.select :as select]
   [oops.core :as oops]
   [reagent.core :as r]
   [common.localization :as loc]
   [ui.components.sortable-list.view :as sortable-list]))

;; FIXME once we have implemented the API for radix ui components asChild correctly
(defn add-entity-type-dropdown
  []
  (let [options @(rf/subscribe [::sub/associated-entity-type-options])
        disabled? (empty? options)
        trigger-comp [button/sm-primary-solid
                      {:disabled? disabled?}
                      (loc/tr :card-editor/add-associated-entity-type)
                      [:i.fal.fa-angle-down]]]
    (if disabled?
      trigger-comp
      [dropdown-menu/view
       {:value            :null
        :items            (->> options
                               (mapv (fn [{:keys [value] :as opt}]
                                       (assoc opt
                                              :on-click #(rf/dispatch [::event/add-entity-type value])))))
        :props            {:hide-arrow? true}
        :trigger-as-child [:span trigger-comp]}])))

(defn no-content-yet
  []
  [:div
   {:class "flex flex-col items-center py-32"}
   [:div (loc/tr :card-editor/no-content-yet)]])

(defn sortable-entity-field-list
  [{:keys [selected-options available-options
           remove-field add-field reorder-items]}]
  [:div
   {:class "flex flex-col gap-2"}
   [sortable-list/view
    {:items selected-options
     :get-key :value
     :gap 4
     :on-reorder (fn [{:keys [source-index destination-index]}]
                   (reorder-items source-index destination-index))
     :render-item (fn [{:keys [item]}]
                    (let [{:keys [label value]} item]
                      [:div
                       {:class "flex gap-3 items-center px-2 py-2 border cursor-default rounded bg-base-light"}
                       [:div
                        {:class "cursor-grab"}
                        [sortable-list/drag-handle-icon]]
                       [:div
                        {:class "grow"}
                        [:p
                         {:class "text-sm m-0"}
                         label]]
                       [:div
                        [button/square-secondary-open
                         {:class    "group"
                          :on-click #(remove-field value)}
                         [:i.fal.fa-trash
                          {:class "group-hover:text-danger-regular text-xs m-0"}]]]]))}]
   [select/view
    {:options     available-options
     :placeholder (loc/tr :add-field)
     :on-change   add-field}]])

(defn entity-peek-settings
  [table-index]
  (let [visible-fields-strategy @(rf/subscribe [::sub/entity-peek-visible-fields-strategy table-index])
        visible-fields @(rf/subscribe [::sub/entity-peek-visible-fields table-index])
        available-options @(rf/subscribe [::sub/entity-peek-field-options table-index])]
    [:div
     {:class "flex flex-col gap-6"}
     [:div
      {:class "flex flex-col gap-2"}
      [:h5
       {:class "font-semibold"}
       (loc/tr :card-editor/entity-peek-settings)]
      [:p
       {:class "text-sm m-0 text-base-light-text-paler"}
       (loc/tr :card-editor/entity-peek-description)]]
     [:div
      {:class "flex flex-col gap-3"}
      [:p
       {:class "font-semibold text-base-light-text"}
       (loc/tr :card-editor/which-fields-you-want-to-show)]
      [radio-group/radio-group-v2
       {:name        (str "table-" table-index "-entity-peek-field-strategy")
        :orientation :horizontal
        :on-change   (fn [value]
                       (rf/dispatch [::event/set-entity-peek-visible-fields-strategy table-index value]))
        :checked     visible-fields-strategy}
       [{:value   :all-fields
         :content (loc/tr :card-editor/entity-peek-all-fields)}
        {:value   :fields-that-have-value
         :content (loc/tr :card-editor/entity-peek-fields-that-have-value)}
        {:value   :selected-fields
         :content (loc/tr :card-editor/entity-peek-selected-fields)}]]]
     (when (= visible-fields-strategy :selected-fields)
       [sortable-entity-field-list
        {:selected-options  visible-fields
         :available-options available-options
         :add-field         #(rf/dispatch [::event/add-entity-peek-field table-index %])
         :remove-field      #(rf/dispatch [::event/remove-entity-peek-field table-index %])
         :reorder-items     (fn [source-index destination-index]
                              (rf/dispatch-sync [::event/reorder-entity-peek-fields table-index source-index destination-index]))}])]))

(defn table-settings
  [table-index]
  (let [group-by-association-type? @(rf/subscribe [::sub/table-group-by-association-type? table-index])
        sort-by-field @(rf/subscribe [::sub/table-sort-by-field table-index])
        sort-direction @(rf/subscribe [::sub/table-sort-direction table-index])
        sort-by-field-options @(rf/subscribe [::sub/selected-table-columns table-index])
        options (remove nil?
                        [{:value :asc
                          :label (loc/tr :ascending)}
                         {:value      :desc
                          :label      (loc/tr :descending)}])]
    [:div
     {:class "flex flex-col gap-3"}
     ;;MIKO pls help me fix this select
     [labelled-input/view
      {:label       (loc/tr :sort-by-text)
       :editor-type :editor.type/select
       :value       (->> sort-by-field-options
                         (cu/filter-by :value (subs (str sort-by-field) 1))
                         (first))
       :on-change   (fn [v]
                      (rf/dispatch [::event/set-table-sort-by-field table-index
                                    v]))
       :options     (->> sort-by-field-options
                         (map (fn [opt]
                                (assoc opt :value (pr-str (:value opt)))))
                         (sort-by :label))}]

     ;;  [:div (loc/tr :sort-by-text)]
     ;;  [:div
     ;;   [:select
     ;;    {:value (subs (str sort-by-field) 1)
     ;;     :on-change (fn [e]
     ;;                  (let [value (-> e
     ;;                                  (oops/oget "target")
     ;;                                  (oops/oget "value")
     ;;                                  keyword)]
     ;;                    (rf/dispatch [::event/set-table-sort-by-field table-index value])))
     ;;     :class "min-w-24"}
     ;;    [:option {:value "-"} "-"]
     ;;    (->> sort-by-field-options
     ;;         (map
     ;;          (fn [{:keys [value label]}]
     ;;            ^{:key (str value)}
     ;;            [:option
     ;;             {:value (subs (str value) 1)}
     ;;             label])))]]

     (when sort-by-field
       [:<>
        [labelled-input/view
         {:label       (loc/tr :sort-direction)
          :editor-type :editor.type/select
          :value       (->> sort-by-field-options
                            (cu/filter-by :value (subs (str sort-direction) 1))
                            (first))
          :on-change   (fn [e]
                         (let [value (-> e
                                         (oops/oget "target")
                                         (oops/oget "value")
                                         keyword)]
                           (rf/dispatch [::event/set-table-sort-direction table-index value])))
          :options     options}]

        ;; [:div
        ;;  [:select
        ;;   {:value (subs (str sort-direction) 1)
        ;;    :on-change (fn [e]
        ;;                 (let [value (-> e
        ;;                                 (oops/oget "target")
        ;;                                 (oops/oget "value")
        ;;                                 keyword)]
        ;;                   (rf/dispatch [::event/set-table-sort-direction table-index value])))}
        ;;   [:option
        ;;    {:value :asc}
        ;;    (loc/tr :ascending)]
        ;;   [:option
        ;;    {:value :desc}
        ;;    (loc/tr :descending)]
        ;;   ]]
        ])
     [:div
      {:class "flex gap-3 items-center"}
      [:div (loc/tr :card-editor/group-by-association-type)]
      [:div
       {:class "inline-flex"}
       [toggle/toggle
        {:checked? group-by-association-type?
         :on-change (fn [checked?]
                      (rf/dispatch [::event/set-group-by-association-type table-index checked?]))}]]]]))

(defn table-settings-section
  [table-index]
  (let [selected-columns @(rf/subscribe [::sub/selected-table-columns table-index])
        available-options @(rf/subscribe [::sub/table-column-available-options table-index])]
    [:div
     {:class "flex flex-col gap-3"}
     [:div
      {:class "flex justify-between items-center gap-3"}
      [:div
       {:class "flex flex-col gap-2"}
       [:h5
        {:class "text-semibold"}
        (loc/tr :card-editor/table-columns)]
       [:p
        {:class "text-sm m-0 text-base-light-text-paler"}
        (loc/tr :card-editor/reorder-columns-by-dragging)]]]
     [sortable-entity-field-list
      {:selected-options  selected-columns
       :available-options available-options
       :reorder-items     (fn [source-index destination-index]
                            (rf/dispatch-sync [::event/reorder-table-columns table-index source-index destination-index]))
       :add-field         (fn [field]
                            (rf/dispatch [::event/add-table-column table-index field]))
       :remove-field      (fn [field]
                            (rf/dispatch [::event/remove-table-column table-index field]))}]

     [table-settings table-index]]))

(defn move-up-down-buttons
  [table-index]
  (let [table-count @(rf/subscribe [::sub/table-count])
        up-disabled? (zero? table-index)
        down-disabled? (= table-index (dec table-count))]
    [:div
     {:class "flex rounded border overflow-hidden"}
     [:div
      {:class (uu/cm (when-not up-disabled?
                       "hover:bg-base-regular"))}
      [button/square-secondary-open
       {:tooltip   (when-not up-disabled?
                     (loc/tr :move-up))
        :disabled? up-disabled?
        :on-click  #(rf/dispatch [::event/reorder-tables table-index (dec table-index)])}
       [:i.fal.fa-arrow-up
        {:class "font-medium text-sm m-0"}]]]
     [:div
      {:class (when-not down-disabled?
                "hover:bg-base-regular")}
      [button/square-secondary-open
       {:tooltip   (when-not down-disabled?
                     (loc/tr :move-down))
        :disabled? down-disabled?
        :on-click  #(rf/dispatch [::event/reorder-tables table-index (inc table-index)])}
       [:i.fal.fa-arrow-down
        {:class "font-medium text-sm m-0"}]]]]))

(defn association-type-editor
  [table-index]
  (let [title @(rf/subscribe [::sub/table-title table-index])
        entity-type @(rf/subscribe [::sub/table-entity-type table-index])]
    [:div
     {:class "flex flex-col gap-5 border rounded p-4"}
     [:div
      {:class "flex justify-between items-center"}
      [:div
       {:class "flex items-center gap-2"}
       [:h4
        {:class "text-lg font-bold"}
        title]]
      [:div
       {:class "flex gap-5 items-center"}
       [move-up-down-buttons table-index]
       [button/square-secondary-open
        {:class    "group"
         :on-click #(rf/dispatch [::event/remove-entity-type entity-type])}
        [:i.fal.fa-trash
         {:class "group-hover:text-danger-regular"}]]]]
     [:div
      {:class "flex items-stretch gap-5"}
      [:div
       {:class "w-1/2"}
       [table-settings-section table-index]]
      [:div
       {:class "w-px bg-base-regular-border-paler"}]
      [:div
       {:class "w-1/2"}
       [entity-peek-settings table-index]]]]))

(defn association-tables
  [_]
  (let [get-table-element-id (fn [table-index]
                               (str "associations-editor-table-" table-index))
        scroll-table-into-view
        (fn [table-index]
          (when-let [el (->> table-index
                             get-table-element-id
                             (oops/ocall js/document "getElementById"))]
            (oops/ocall el "scrollIntoView" (clj->js {:behavior :smooth}))))]
    (r/create-class
     {:component-did-update
      (fn [this old-argv]
        (let [prev-table-count (-> old-argv
                                   (nth 1)
                                   :table-count)
              new-props (r/props this)
              new-table-count (:table-count new-props)]
          (when (< prev-table-count new-table-count)
            (scroll-table-into-view (dec new-table-count)))))
      :reagent-render
      (fn [{:keys [table-count]}]
        [:div
         {:class "grid grid-cols-1 gap-5"}
         (->> (range table-count)
              (map (fn [table-index]
                     ^{:key (str table-index)}
                     [:div
                      {:id (get-table-element-id table-index)}
                      [association-type-editor table-index]])))])})))

(defn view
  []
  (let [table-count @(rf/subscribe [::sub/table-count])]
    [:div
     {:class "pt-3 flex flex-col gap-3"}
     [:div
      {:class "flex justify-between items-center"}
      [:h4
       {:class "font-bold text-xl"}
       (loc/tr :card-editor/card-content-label)]
      [add-entity-type-dropdown]]
     (if (pos? table-count)
       [association-tables
        {:table-count table-count}]
       [no-content-yet])]))
